export const SMALL = 20;
export const MEDIUM = 30;
export const LARGE = 40;
